import { Component, Input, OnChanges } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';
import { ChartConfiguration } from 'chart.js';
import { DeliveryRateByGroup } from '../../../../../pages/organization/campaigns/types/messagesTypes';
import { ThemedChart } from '../themed-chart';
import { barChartHeight, formatPercent, shareBarConfig } from '../chart-theme';

/** Delivery rate per recipient group, best first: ink bars on the track colour. */
@Component({
  selector: 'app-delivery-rate-by-recipients-graph',
  standalone: true,
  imports: [BaseChartDirective],
  templateUrl: './delivery-rate-by-recipients-graph.component.html',
  styleUrl: '../report-graph.css',
})
export class DeliveryRateByRecipientsGraphComponent extends ThemedChart implements OnChanges {
  @Input() graphData: any;

  groups: DeliveryRateByGroup[] = [];
  chartData: ChartConfiguration<'bar'>['data'] = { labels: [], datasets: [] };
  chartOptions: ChartConfiguration<'bar'>['options'] = {};
  height = barChartHeight(2);

  ngOnChanges() {
    const list: DeliveryRateByGroup[] = Array.isArray(this.graphData) ? this.graphData : [];
    this.groups = list
      .filter((group) => !!group)
      .map((group) => ({ ...group, deliveryRate: Number(group.deliveryRate) || 0 }))
      .sort((a, b) => b.deliveryRate - a.deliveryRate);
    this.redraw();
  }

  protected render() {
    const labels = this.groups.map((group) => group.groupName || 'Unnamed group');
    const values = this.groups.map((group) => group.deliveryRate);
    const { data, options } = shareBarConfig(this.tokens, labels, values, (index, value) => {
      const type = String(this.groups[index]?.groupType ?? '').toLowerCase();
      return `${formatPercent(value)} delivered${type ? ` · ${type}` : ''}`;
    });
    this.chartData = data;
    this.chartOptions = options;
    this.height = barChartHeight(this.groups.length);
  }
}
